import React, {useState, useRef, useEffect} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {t} from 'react-switch-lang';
import {
  getAllCostEstimations,
  createCostEstimation,
  deleteCostEstimation,
  updateCostEstimation,
} from '../../../services/costEstimationsService';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import AddIcon from './plus.png';
import './CostEstimations.scss';
import {validNameandNumberEngMneSymbolsRegex} from '../../../utils/const';
import Swal from "sweetalert2"
const CostEstimations = () => {

  const [costEstimations, setCostEstimations] = useState([]);
  const [query, setQuery] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllCostEstimations();
        setCostEstimations(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  const columns = [
    {
      dataIndex: 'cost',
      title: t('costEstimations.cost'),
      editable: true,
      placeholder: t('costEstimations.placeholder.cost'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneSymbolsRegex,
          message: t('message.fieldNotValid'),
        },
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
       
        {max: 255, message: t('message.max', {max: 255})},

      ],
    },
  ];

  const onUpdate = async (data, editingRecord, form) => {
    data.id = editingRecord.id;
//  data.cost = data.cost.trim();
    try {
      const response = await updateCostEstimation(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('costEstimations.message.updateSuccess', {
            entity: t('costEstimations.costEstimation'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {}
  };
  const onCreate = async (data, form) => {
    // data.cost = data.cost.trim();
    try {
      const response = await createCostEstimation(data);
      if (response.status === 201) {
        Toast.fire({
          title: t('costEstimations.message.addSuccess', {
            entity: t('costEstimations.costEstimation'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {}
  };
  const onDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteCostEstimation'),
        text: t('question.deleteCostEstimation', {
          entity: record.cost,
        }),
        confirmButtonText: t('common.delete').toUpperCase(),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            const response = await deleteCostEstimation(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('costEstimations.message.deleteSuccess', {
                  entity: t('costEstimations.costEstimation'),
                }),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: `${t('message.errorDeleteCost')}`,
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        },
      });
    });
  };

  const addButton = useRef();
  return (
    <div className="users administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search-field">
          <SearchBox
         
            placeholder={t('costEstimations.placeholder.search')}
            setQuery={setQuery}
          />
        </div>
        <div className="button-add">
          <button className="btn btn-primary" ref={addButton}>
            <img src={AddIcon} alt="" />
            <p> {t('costEstimations.add')}</p>
          </button>
        </div>
      </div>
      <CustomTable
        api="/cost-estimations"
        columns={columns}
        query={query}
        queryParamName="cost.contains"
        methods={{onUpdate, onDelete, onCreate}}
        addButtonRef={addButton}
      />
    </div>
  );
};

export default CostEstimations;
